__webpack_require__.p = "https://static.parastorage.com/services/restaurant-menus-showcase-ooi/073a3ac4383d1e96d248a442e17e560c4897d0993d9b4167bb521fd8/";